import { convertToFahrenheit } from "../../../../services/convertUnits";
import { SearchSliderSettings } from "../settings/slider";

type GenerateSliderValueTextProps = {
    value: number | number[];
    unit: string;
    measure: string;
};

const getValuesAndType = (
    value: number | number[],
    settings: typeof SearchSliderSettings[keyof typeof SearchSliderSettings],
    unit?: string
): string | null => {
    const { isFromSelectedValueUp, isTemperature, min, max } = settings;
    if (!isTemperature) {
        if (
            (isFromSelectedValueUp && min == value) ||
            (!isFromSelectedValueUp && max == value)
        ) {
            return null;
        }
        const sign = isFromSelectedValueUp ? ">" : "<";
        let base = `${sign} ${value}`;
        if (unit) {
            base += ` ${unit}`;
        }
        return base;
    }
    let low = null;
    let high = null;
    if (min != value[0]) {
        low = value[0];
    }
    if (max != value[1]) {
        high = value[1];
    }
    if (low == null && high == null) {
        return null;
    }
    if (unit == "F") {
        low = low != null ? Math.round(convertToFahrenheit(low)) : null;
        high = high != null ? Math.round(convertToFahrenheit(high)) : null;
    }
    if (low != null && high != null) {
        return `${low} °${unit} - ${high} °${unit}`;
    }
    const sign = low != null ? ">" : "<";
    return `${sign} ${low != null ? low : high} °${unit}`;
};

export const generateSliderValueText: (
    GenerateSliderValueTextProps
) => string = ({ value, unit, measure }) => {
    const settings = SearchSliderSettings[measure.split(".")[1]];
    const label = getValuesAndType(value, settings, unit);
    return label;
};
